import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { BrowserRouter as Router } from 'react-router-dom';

import Homepage from './homepage'
import Payment from './payment'
import PaymentRegular from './payment-regular'
import Thanks from './thanks'
import Failed from './failed'

import ScrollToTop from '../components/scroll-to-top'

const Views: React.FC = (props: any) => {
    return (
      <main className="row" id="main" tabIndex={-1}>
        <div className="columns large-12">
          <Router>
            <ScrollToTop />
            <Routes>
              <Route path='/donate/:url' element={<Homepage {...props} />} />
              <Route path='/donate/:url/payment' element={<Payment {...props} />} />
              <Route path='/donate/:url/payment_regular' element={<PaymentRegular {...props} />} />
              <Route path='/donate/:url/thanks' element={<Thanks {...props} />} />
              <Route path='/donate/:url/failed' element={<Failed {...props} />} />
            </Routes>
          </Router>
        </div>
      </main>
    )
}

export default Views